import React, { Component } from 'react';
import { PaginatorHeader, DateToggleButton } from './style';
import { TruncatedText } from '../../UI/Text';
import {
    addDay,
    substractDay,
    formatDateForServer,
    getFormattedDateFromDateObject,
} from '../../../Utils/timeConvertorHelper';
import { timeFormats } from '../../../Constants/timeFormats';

class CalendarPaginator extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dateSelected: new Date(),
            listBackAllowed: false,
        };
    }

    addCalendarDay = () => {
        const { dateSelected } = this.state;

        let newDay = addDay(dateSelected);
        this.setState({ dateSelected: new Date(newDay), listBackAllowed: true }, () => {
            this.props.onChangeDate(formatDateForServer(this.state.dateSelected));
        });
    };

    substractCalendarDay = () => {
        const { dateSelected, listBackAllowed } = this.state;

        let newDay = substractDay(dateSelected);

        if (
            (getFormattedDateFromDateObject(new Date(newDay), timeFormats.FULL_DAY_NAME_MON_DAY_ORDER) ===
                getFormattedDateFromDateObject(new Date()),
            timeFormats.FULL_DAY_NAME_MON_DAY_ORDER)
        ) {
            this.setState({ listBackAllowed: false });
        }

        if (listBackAllowed) {
            this.setState({ dateSelected: new Date(newDay) }, () => {
                this.props.onChangeDate(formatDateForServer(this.state.dateSelected));
            });
        }

        return;
    };

    render() {
        const { dateSelected, listBackAllowed } = this.state;

        return (
            <PaginatorHeader>
                <DateToggleButton onClick={listBackAllowed ? this.substractCalendarDay : null} hide={!listBackAllowed}>
                    <i className="fas fa-chevron-left" />
                </DateToggleButton>

                <TruncatedText padding={'0 10px'} weight={'bold'} fontSize={16}>
                    {getFormattedDateFromDateObject(dateSelected, timeFormats.FULL_DAY_NAME_MON_DAY_ORDER)}
                </TruncatedText>

                <DateToggleButton onClick={this.addCalendarDay}>
                    <i className="fas fa-chevron-right" />
                </DateToggleButton>
            </PaginatorHeader>
        );
    }
}

export default CalendarPaginator;



// WEBPACK FOOTER //
// ./src/UI/Containers/CheckIn/CalendarPaginator.js